export const FilespaceSettingsUpgradeTestIdFactory = {
    getFilespaceSettingsUpgradeBase: () => 'filespace-upgrade',
    getFilespaceSettingsUpgradeTestId: (testId) => [
        FilespaceSettingsUpgradeTestIdFactory.getFilespaceSettingsUpgradeBase(),
        testId,
    ].join('-'),
};
